// extracted by mini-css-extract-plugin
export default {"container":"Content-module__container__ZJhbeWM","pagination":"Content-module__pagination__NmAsClQ"};